const initState = {
  socialApps: [],
  socialAppGoogle: {},
  socialAppFacebook: {},
  socialAppLinkedIn: {},
  loading: false,
  error: false,
}

const reducer = (state = initState, action) => {
  switch (action.type) {
    case 'SET_SOCIAL_APPS':
      return {...state, socialApps: action.payload}
    case 'SET_SOCIAL_APP_GOOGLE': 
      return {...state, socialAppGoogle: action.payload}
    case 'SET_SOCIAL_APP_FACEBOOK':
      return {...state, socialAppFacebook: action.payload}
    case 'SET_SOCIAL_APP_LINKEDIN': 
      return {...state, socialAppLinkedIn: action.payload}
      case 'SET_LOADING': 
      return {...state, loading: action.payload}
    case 'SET_ERROR':
      return {...state, error: action.payload}
    default: 
      return state
  }
}

export default reducer